import ReactDOM from "react-dom"
import { localeFromPathname, setLocale } from "../i18n"

export const initReactApp = (ReactApp: JSX.Element, rootId = "react-root"): void => {
  document.addEventListener("DOMContentLoaded", () => {
    const reactRoot: HTMLElement | null = document.getElementById(rootId)
    if (!reactRoot) return
    setLocale(localeFromPathname())
    ReactDOM.render(ReactApp, reactRoot)
  })
}
